import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IAiSidebar} from "../reducers/ai-sidebar.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getAiSidebarState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.aiSidebar);


export const getAiSidebarToggled = createSelector(getAiSidebarState,
  (state: IAiSidebar): boolean =>
    state.toggled
);
